<template>
    <div class="v-nav-dropdown">
        <slot>
            <!---->
        </slot>
    </div>
</template>
<script lang="ts">
import { Component } from 'vue-property-decorator';
import BaseComponent from './Base';

@Component
export default class NavDropdown extends BaseComponent {

}
</script>
